import React from 'react';
import { Link } from 'react-router';
import Moment from 'moment';
import MomentRu from 'moment/locale/ru';
import $ from 'jquery';

class FeedMore extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            delta: 0,
            currentDrag: 0
        };
        this.prevDrag = 0;
    }

    __convertDate(date) {
        return Moment(date).format('DD.MM.YYYY H:mm:ss');
    }

    __clickHideHandler(event) {
        event.preventDefault();
        this.props.hideMore();
    }

    componentDidMount() {
        window.feedMoreTouch = true;
        $('.m2content__feed_more').scroll(function(event) {

            window.feedMoreTouch = false;
            clearTimeout(window.feedMoreInterval);
            window.feedMoreInterval = setTimeout(function(){
                window.feedMoreTouch = true;
            }, 700);
        });
    }

    __touchStart(event) {
        this.prevDrag = event.changedTouches[0].clientX;
        this.setState({currentDrag: event.changedTouches[0].clientX});
    }

    __touchEnd(event)   {
        this.prevDrag = 0;
        if(Math.abs(this.state.delta) > 100) {
            this.setState({delta: 0,currentDrag: 0});
            this.props.hideMore();
        } else {
            this.setState({delta: 0, currentDrag: 0});
        }
    }

    __touchMove(event)  {
        if(window.feedMoreTouch) {
            let clientX = event.changedTouches[0].clientX;
            let delta = this.state.currentDrag - clientX;
            this.setState({delta: Math.abs(delta)});
            if(Math.abs(delta) > 100) {
                this.setState({delta: 0});
                this.props.hideMore();
            }
        }
    }

    clickBookmark(event) {
        event.preventDefault();
        this.props.addToBookmark(this.props.id);
    }

    render() {
        let styles = {
            opacity: 1
        };
        if(window.feedMoreTouch) {
            let opacity = 1 - (this.state.delta/100);
            styles = {
                transform: 'translateX(' + Math.abs(this.state.delta) + 'px)',
                WebkitTransform: 'translateX(' + Math.abs(this.state.delta) + 'px)',
            };
        }


        return (
            <div style={styles}  className="m2feed_more" onTouchStart={this.__touchStart.bind(this)} onTouchEnd={this.__touchEnd.bind(this)} onTouchMove={this.__touchMove.bind(this)}>
                {this.props.title ? <div className="m2feed_more_wrapper">
                    <div className="m2feed_mobile_options">
                        <Link onClick={this.__clickHideHandler.bind(this)} to="#" className="m2btn_back"><span>Назад</span></Link>
                        <div className={"m2feed_mobile_buttons"}>
                            <Link onClick={this.clickBookmark.bind(this)} to="#" className={"m2btn_bookmark" + (this.props.bookmark ? " m2btn_bookmark_active": "")}></Link>
                        </div>
                    </div>
                    <div className="m2feed_content_more_wrapper">
                        <div className="m2feed_options">
                            <div className="m2feed_more__source"><b>Источник: </b> {this.props.source_name} </div>
                            <div className="m2feed_more_data">Дата: {this.__convertDate(this.props.feed_date)}</div>
                            <div className="m2feed_more_categories">Метки: {this.props.category.length > 0 ? this.props.category.join(', ') : ''}</div>
                        </div>
                        <div className="m2feed_more_main">
                            <div className="m2feed_more_title" dangerouslySetInnerHTML={{__html: this.props.title}}></div>
                            <div className="m2feed_more_description" dangerouslySetInnerHTML={{__html: (this.props.html_text || this.props.description)}}></div>
                        </div>
                        {!this.props.hideOpenWindow && <div className="m2feed_more_buttons">
                            <Link to={"/feeds/feedmore/" + this.props.id} target="_blank">Открыть в новом окне</Link>
                        </div>}
                    </div>
                </div> : <div></div>}
            </div>
        );
    }
}

export default FeedMore;


// WEBPACK FOOTER //
// ./src/components/FeedMore.js